
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AuthService } from '../services/auth.service'
import { debounceTime } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthReverseGuard implements CanActivate {

  private loader$ = new Subject<boolean>();
  public loader = false;

  constructor(public authService: AuthService, public router: Router, public configService: ConfigService) {
    this.loader$.pipe(debounceTime(300)).subscribe(loader => { this.loader = loader })
  }

  async canActivate(): Promise<boolean> {
    console.debug("AuthReverseGuard");
    this.setShowLoader(true);
    try {
      await this.configService.getInitialInfo();
      var isLogged = await this.authService.checkAutentication()
    } catch (error) {
      this.setShowLoader(false)
      this.router.navigateByUrl('/inicio');
      this.configService.getInitialInfo(true);
      return true;
    }

    if (!isLogged) {
      this.setShowLoader(false)
      return true
    }
    this.setShowLoader(false)
    this.router.navigateByUrl('/inicio');
    this.configService.getInitialInfo(true);
    return false
  }

  setShowLoader(show) {
    this.loader$.next(show);
  }

}

